/**
 * TODO 1 This definition could be done in TS. Should it be part of valid-values project?
 * TODO We should start with pure elabels import. So this could go under elabelDataImport import type
 */
export const elabelFields = [
  {
    key: 'elabel.externalId',
    unique: true,
    label: 'Unique private E-label ID',
  },
  {
    key: 'elabel.shortCode',
    readonly: true,
    unique: true,
    label: 'Unique Bottlebooks generated QR Url short code',
  },
  {
    key: 'elabel.productType',
    label: 'E-label product type',
  },
  {
    key: 'elabel.name',
    label: 'E-label private name',
  },
  {
    key: 'elabel.countries.0.key',
    label: 'E-label country',
  },
  {
    key: 'elabel.product.shortName',
    label: 'E-label Product name',
  },
  {
    key: 'elabel.producer.name',
    label: 'E-label Producer marketing name',
  },
];
